import React, { useState } from 'react';

import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import { FilterInputProps } from './types';

type Props = FilterInputProps & {
  valueExtractor?: (expression: string | null) => string | null;
};

export const getFilterExpression = (filterExpression: string, value: string) =>
  filterExpression.replace('?', value);

const getValueFromFilterExpression = (filterExpression: string | null) =>
  filterExpression ? (filterExpression.match(/'([^']+)'/) || [])[1] || null : null;

export const ReportGenericSearchTermFilter = ({
  defaultValue,
  filterExpression,
  filterLabel,
  onChange,
  selectedFilter,
  valueExtractor,
}: Props) => {
  const value = valueExtractor
    ? valueExtractor(selectedFilter)
    : getValueFromFilterExpression(selectedFilter);
  const [searchTerm, setSearchTerm] = useState(value ?? defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    if (e.target.value === '') {
      onChange(null);
    } else {
      onChange(getFilterExpression(filterExpression, e.target.value));
    }
  };

  return (
    <FormControl>
      <TextField
        label={filterLabel}
        onChange={handleChange}
        size="small"
        sx={{
          maxWidth: 160,
        }}
        value={searchTerm}
      />
    </FormControl>
  );
};
